module.exports = "<div class=\"ui-card padding-md\">\r\n  <div class=\"ui-item\">\r\n    <div class=\"flex\">\r\n      <h1 class=\"ui-title margin-lg\">Pagos</h1>\r\n    </div>\r\n  </div>\r\n</div>\r\n<nav class=\"ui-card ui-tabs\">\r\n  <a class=\"ui-tabs-tab padding-md\"\r\n      ui-sref-active=\"active\"\r\n      ui-sref=\"viaticos.pagos.pendientes()\">\r\n    Pendientes\r\n  </a>\r\n  <a class=\"ui-tabs-tab padding-md\"\r\n      ui-sref-active=\"active\"\r\n      ui-sref=\"viaticos.pagos.realizados()\">\r\n    Realizados\r\n  </a>\r\n</nav>\r\n<section ui-view></section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/pagos/template.html
// module id = 3256
// module chunks = 0